module.exports = __webpack_public_path__ + "static/media/gif1.2cc931e0.gif";